import { render, staticRenderFns } from "./ConstructorSelector.vue?vue&type=template&id=0048c03e"
import script from "./ConstructorSelector.vue?vue&type=script&lang=js"
export * from "./ConstructorSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports